import { defineMessages } from '@sevenrooms/locales'

export const otherDaysAvailabilityMessages = defineMessages({
  scrollLeftLabel: {
    id: 'otherdays.availability.leftlabel',
    defaultMessage: 'scroll {date} left',
  },
  scrollRightLabel: {
    id: 'otherdays.availability.rightlabel',
    defaultMessage: 'scroll {date} right',
  },
})
